export default __webpack_public_path__ + "static/media/navicon-othertransaction.fb144302.svg";